<nz-alert
    nzType="info"
    nzMessage="Read-Only Mode"
    [nzDescription]="warning ? warning : 'You do not have permission to edit the below details. This view is for informational purposes only.'"
    nzShowIcon
    style="margin-bottom: 20px;">
</nz-alert>